import React from 'react';
import cornerImage from '@assets/images/corner.png';
import './CornerDecoration.css';

export const CornerDecoration: React.FC = () => {
  return (
    <img
      src={cornerImage}
      alt=""
      className="corner-decoration"
      aria-hidden="true"
    />
  );
};

export default CornerDecoration;
